export function removeHyperlinksAndSpecialChars(text: string): string {
  if (!text) {
    return text;
  }

  // Remove hyperlinks
  const withoutHyperlinks = text.replace(/(https?:\/\/[^\s]+)/g, '');

  // Remove special characters except '1'
  let withoutSpecialChars:any = withoutHyperlinks.replace(/[\';,?><`~]/g, '');
  //removing space from first charecter
  if (withoutSpecialChars.startsWith(' ')) {
    withoutSpecialChars = withoutSpecialChars.trimStart();
  }

  return withoutSpecialChars;
}